import React from 'react';

const ContTitle = ({ title }) => {
  return (
    <div className="cont__title">
      <h2>{title}</h2>
    </div>
  );
};

export default ContTitle;
